GLOBAL.ServerTime = Static({
    interval: null,
    diff: 0,

    sync: function() {
        var self = this;

        Xhr.request('system/timestamp', function (timestamp, error) {
            if (!error) {
                timestamp *= 1000;

                var local = Date.now();

                self.diff = local - timestamp;
            } else {
                console.log("ServerTime error");
            }
        });
    },

    setTimestamp: function(timestamp) {

        var local = Date.now();

        this.diff = local - (+timestamp) * 1000;
    },

    start: function(period) {
        var self = this;

        period = Util.coalesce(period, 60000);

        if (!this.interval) {
            this.sync();

            this.interval = setInterval(function() {
                self.sync();
            }, period);
        }
    },

    stop: function() {
        if (this.interval) {
            clearInterval(this.interval);

            this.interval = null;
        }
    },

    now: function() {
        return Date.now() - this.diff;
    },

    date: function() {
        return new Date(this.now());
    }
});
